import React from "react";

import { Box, Typography } from "@mui/material";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";

import { ICONS } from "../static/icons";
import { getCamelCaseWord } from "../utils/functions";

const CandidateJobRequirementsMatch = ({ score, extracted_data = {} }) => {
  // console.log("extracted_data", extracted_data);
  const isResumeScoreCalculated =
    typeof score === "object" && Object.keys(score || {}).length > 0;

  return (
    <Box border="1px solid #EDEDED" borderRadius="5px">
      <Box display="flex" border="1px solid #EDEDED">
        <Box flex={1} textAlign="center" p={2}>
          <Typography color="#909090" fontSize="14px" fontFamily="Outfit">
            Attributes
          </Typography>
        </Box>
        <Box flex={1} textAlign="center" p={2}>
          <Typography color="#909090" fontSize="14px" fontFamily="Outfit">
            Required
          </Typography>
        </Box>
        <Box flex={1} textAlign="center" p={2}>
          <Typography color="#909090" fontSize="14px" fontFamily="Outfit">
            Matched
          </Typography>
        </Box>
        <Box flex={1} textAlign="center" p={2}>
          <Typography color="#909090" fontSize="14px" fontFamily="Outfit">
            Percent
          </Typography>
        </Box>
      </Box>
      {isResumeScoreCalculated &&
        Object.keys(score).map((key, index) => {
          const field = score[key];
          const value =
            Array.isArray(field?.value) && field?.value?.length > 0
              ? field?.value?.join(", ")
              : field?.value || "--";

          const matchedValue =
            key === "experience"
              ? extracted_data?.relevant_experience?.value
              : extracted_data?.[key]?.value;

          const matched = Array.isArray(matchedValue)
            ? matchedValue.length > 0
              ? matchedValue.join(", ")
              : "--"
            : matchedValue || "--";

          return (
            <Box
              key={key}
              display="flex"
              bgcolor={index % 2 >= 1 ? "#F4FCFD" : "white"}
              border="1px solid #EDEDED"
            >
              <Box
                flex={1}
                pl={1}
                textAlign="center"
                py={2}
                display="flex"
                gap={1}
                justifyContent="center"
              >
                <Box flex={0.2}>{ICONS[key]}</Box>
                <Typography
                  flex={0.3}
                  textAlign="left"
                  fontFamily="Outfit"
                  color="#4B5961"
                  fontSize="15px"
                >
                  {key === "skills"
                    ? "Technical Skills"
                    : getCamelCaseWord(key)}
                </Typography>
              </Box>
              <Box flex={1} textAlign="center" py={2}>
                <Typography
                  textAlign="center"
                  color="#4C5C64"
                  fontFamily="Outfit"
                  fontSize="15px"
                >
                  {value}
                </Typography>
              </Box>
              <Box flex={1} textAlign="center" py={2}>
                <Box
                  sx={{
                    maxHeight: "100px",
                    overflowY: "auto",
                    textAlign: "center",
                    color: "#4C5C64",
                    fontFamily: "Outfit",
                    fontSize: "15px",
                  }}
                >
                  {matched}
                </Box>
              </Box>
              <Box
                flex={1}
                textAlign="center"
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Box width="45px" height="45px">
                  <CircularProgressbarWithChildren
                    value={field?.matching_score || 0}
                    strokeWidth={6}
                    styles={buildStyles({
                      rotation: 0.2,
                      pathColor: `#1B9CCA`,
                      trailColor: "transparent",
                    })}
                  >
                    <Typography
                      color="#30ADF3"
                      fontFamily="Outfit"
                      textAlign="center"
                      fontSize="13px"
                      mb={1.4}
                    >
                      {`${Math.floor(field?.matching_score || 0)}%`}
                    </Typography>
                  </CircularProgressbarWithChildren>
                </Box>
              </Box>
            </Box>
          );
        })}
    </Box>
  );
};

export default CandidateJobRequirementsMatch;
